import type {
    TCreateSetState,
    IState,
    IFields,
    INameKeys,
    INameState,
    TGenderSelection,
    IActionsClass,
    TFieldRenderProps,
} from '../models';

/**
 * Создает setState, который можно вызывать многократно и перечислять
 * ключи изменяемых полей в качестве аргументов
 * Используется функция внутри setState, чтобы можно было многократно
 * обновлять множество полей в разных ветках
 */
export const createSetState: TCreateSetState = setState => (arg1, arg2, arg3) =>
    setState(prevState => {
        if (typeof arg3 !== 'undefined') {
            return {
                ...prevState,
                [arg1]: {
                    ...prevState[arg1 as keyof INameKeys],
                    [arg2 as keyof INameState]: arg3,
                },
            };
        }

        return {
            ...prevState,
            [arg1]: arg2,
        };
    });

const genderCondition = (firstEqualElem: string, secondEqualElem: string, thirdElem: string) => {
    if (firstEqualElem === secondEqualElem && (thirdElem === firstEqualElem || !thirdElem)) {
        return firstEqualElem;
    }

    return false;
};

/** См. аналитику http://confluence.moscow.alfaintra.net/x/5Sd-EQ */
export const genderSelection: TGenderSelection = ({ firstName, lastName, middleName }) => {
    if (lastName || firstName || middleName) {
        const firstCompare = genderCondition(lastName, firstName, middleName);
        const secondCompare = genderCondition(lastName, middleName, firstName);
        const thirdCompare = genderCondition(middleName, firstName, lastName);

        if (firstCompare) {
            return firstCompare;
        }
        if (secondCompare) {
            return secondCompare;
        }
        if (thirdCompare) {
            return thirdCompare;
        }
    }

    return false;
};

export const showGender = ({ firstName, gender, lastName, middleName }: IFields, state: IState) =>
    // Нет значения пола и пол невозможно опрелелить проверкой
    !(gender?.input.value && genderSelection(state.gender)) &&
    // В фамилии/имени есть значение, пользователь вышел из поля
    lastName.input.value &&
    lastName.meta.touched &&
    firstName.input.value &&
    firstName.meta.touched &&
    // Нет отчества или та же проверка что на имя/фамилию
    ((middleName.input.value && middleName.meta.touched) || !state.hasMiddleName);

const keys: Array<keyof INameState> = ['firstName', 'middleName', 'lastName'];

export const checkValues = (
    key: keyof IActionsClass['fields'],
    state: INameState<TFieldRenderProps>
) => keys.filter(cur => cur !== key).every(cur => state[cur].input.value);
